import React from "react";

// Farb-Töne pro Bearbeitungsstatus
export const TONE = {
  neu: "border-[#A3E635]/40 bg-[#A3E635]/10 text-[#A3E635]",
  in_bearbeitung: "border-blue-400/40 bg-blue-400/10 text-blue-300",
  besichtigung_geplant: "border-blue-400/40 bg-blue-400/10 text-blue-300",
  aufgabe_erstellt: "border-cyan-400/40 bg-cyan-400/10 text-cyan-300",
  offerte_vorbereitet: "border-violet-400/40 bg-violet-400/10 text-violet-300",
  angebot_vorbereitet: "border-violet-400/40 bg-violet-400/10 text-violet-300",
  rueckfrage_offen: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  warten_auf_kunde: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  reserviert: "border-fuchsia-400/40 bg-fuchsia-400/10 text-fuchsia-300",
  verkauft: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  erledigt: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  archiviert: "border-white/15 bg-white/5 text-gray-400",
};

export const PRIORITIES = [["niedrig", "Niedrig"], ["mittel", "Mittel"], ["hoch", "Hoch"], ["dringend", "Dringend"]];
export const PRIO_TONE = {
  dringend: "text-red-300 bg-red-400/10 border-red-400/30",
  hoch: "text-amber-300 bg-amber-400/10 border-amber-400/30",
  mittel: "text-gray-300 bg-white/5 border-white/10",
  niedrig: "text-gray-400 bg-white/5 border-white/10",
};

export function projectTypeForBranche(b) {
  b = (b || "").toLowerCase();
  if (b.includes("brocki") || b.includes("secondhand") || b.includes("fundgrube")) return "brocki";
  if (b.includes("garten") || b.includes("landschaft")) return "garten";
  return "default";
}

export const StatusPill = ({ status, label, testid }) => (
  <span data-testid={testid} className={`text-[11px] px-2.5 py-1 rounded-full border font-semibold whitespace-nowrap ${TONE[status] || TONE.archiviert}`}>
    {label || status}
  </span>
);

export const PrioPill = ({ p }) => (
  <span className={`text-[10px] px-2 py-0.5 rounded-full border font-bold uppercase tracking-wide ${PRIO_TONE[p] || PRIO_TONE.mittel}`}>{p || "mittel"}</span>
);

export const TYPE_TONE = {
  kunden_anfrage: "bg-blue-400/10 text-blue-300 border-blue-400/30",
  neukunden_lead: "bg-[#A3E635]/10 text-[#A3E635] border-[#A3E635]/30",
  support_anfrage: "bg-amber-400/10 text-amber-300 border-amber-400/30",
  verkaufschance: "bg-fuchsia-400/10 text-fuchsia-300 border-fuchsia-400/30",
};
export const TypePill = ({ type, label }) => (
  <span className={`text-[10px] px-2 py-0.5 rounded-full border font-bold ${TYPE_TONE[type] || TYPE_TONE.kunden_anfrage}`}>{label || type}</span>
);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return iso; }
};

export const inputCls = "w-full bg-black border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A3E635] transition-colors";
